import { useMutation } from "@apollo/client";
import { parseError } from "apollo";
import Button from "components/base/Button";
import { Alert } from "components/base/Toast";
import { RECOMPUTE_PRODUCTION_PLAN } from "./graphql";

const TryRecomputeView = ({ planId, onCompleted }) => {
  const [recomputePlan, recomputePlanRes] = useMutation(
    RECOMPUTE_PRODUCTION_PLAN,
    {
      variables: { planId },
      onCompleted(res) {
        Alert("success", "Recomputed Success.");
        onCompleted(res);
      },
      onError(error) {
        Alert("error", parseError(error));
      },
    },
  );

  return (
    <div>
      <div className=" space-y-4">
        <div className="font-semibold">
          Are you sure to recompute this production plan?
        </div>
        <div className="leading-relaxed opacity-70">
          <p>
            Note that recompute a production plan might effect the production
            date for the later plans.
          </p>
        </div>
      </div>

      <hr />

      <div className="flex space-x-8">
        <Button
          danger
          onClick={recomputePlan}
          loading={recomputePlanRes.loading}
        >
          Yes, Recompute Now.
        </Button>
      </div>
    </div>
  );
};

export default TryRecomputeView;
